/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Email_Settings_Banner_DescInputs */

const en_admin_email_settings_banner_desc = /** @type {(inputs: Admin_Email_Settings_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload a banner image that will be displayed at the top of all outgoing emails.`)
};

const de_admin_email_settings_banner_desc = /** @type {(inputs: Admin_Email_Settings_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden Sie ein Banner-Bild hoch, das oben in allen ausgehenden E-Mails angezeigt wird.`)
};

/**
* | output |
* | --- |
* | "Upload a banner image that will be displayed at the top of all outgoing emails." |
*
* @param {Admin_Email_Settings_Banner_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_email_settings_banner_desc = /** @type {((inputs?: Admin_Email_Settings_Banner_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Email_Settings_Banner_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_email_settings_banner_desc(inputs)
	return en_admin_email_settings_banner_desc(inputs)
});